import { SET_VISIBLE_LOADING, SET_LOADING_LOCAL, SET_LOADING_MAPA, LOADING_START, LOADING_END, LOADING_RESET } from './actionTypes';

export const showLoading = (visible) => ({
  type: SET_VISIBLE_LOADING,
  payload: visible
});

export const showLoadingLocal = (visible) => ({
  type: SET_LOADING_LOCAL,
  payload: visible
});

export const showLoadingMapa = (visible) => ({
  type: SET_LOADING_MAPA,
  payload: visible
});

export const loadingStart = () => ({
  type: LOADING_START
});

export const loadingEnd = () => ({
  type: LOADING_END
});

export const loadingReset = () => ({
  type: LOADING_RESET
});